// `text.enhance`: live's Enhance Script (#224).
// Live's script tools (the smiley beside a script) build these; live lists no such row.
import { TextEnhanceQuote, TextEnhanceRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";
import { commonFields } from "./shared";

export const jobType: JobTypeModule<"text.enhance"> = {
  type: "text.enhance",
  label: "Script enhancement",
  source: "form",
  pair: "text.enhance",
  fields: (draft) => commonFields(draft),
  request: TextEnhanceRequest,
  quote: TextEnhanceQuote,
};
